import { useTranslation } from 'react-i18next';

interface Props {}

const HubTrapsChartTitle: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className="card-header d-flex flex-column flex-md-row gap-2 align-items-center justify-content-between">
      <div className="d-flex justify-content-center flex-column">
        <h5 className="card-title mb-0">{t('HubDetail.chart.title')}</h5>
        <p className="text-muted mb-0 fs-12">{t('HubDetail.chart.subTitle')}</p>
      </div>
    </div>
  );
};

export default HubTrapsChartTitle;
